const PasswordInput = ({ id, showPassword, setFunction, placeholder }) => {
  const onChangeInput = (e, setFunction) => {
    setFunction(e.target.value);
  };

  return (
    <input
      id={id}
      onChange={(e) => onChangeInput(e, setFunction)}
      type={showPassword ? "text" : "password"}
      className="bg-input-gray text-xl px-2 py-2 text-custom-gray"
      placeholder={placeholder}
    />
  );
};

export default PasswordInput;
